import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import meeting from "./modules/meeting";
import apartment from "./modules/apartment";
import vote from "./modules/vote";
import statistics from "./modules/statistics";
import representation from "./modules/representation";
import building from "@/store/modules/buildings";
import system from "@/store/modules/system";
import documents from "@/store/modules/documents";

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    auth,
    user,
    meeting,
    vote,
    statistics,
    representation,
    building,
    system,
    apartment,
    documents,
  },
  state: {},
  mutations: {},
  actions: {},
});
